import { render, staticRenderFns } from "./BaseRow.vue?vue&type=template&id=736332c6&scoped=true&"
import script from "./BaseRow.vue?vue&type=script&lang=js&"
export * from "./BaseRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseRow.vue?vue&type=style&index=0&id=736332c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736332c6",
  null
  
)

export default component.exports